import { clsx, type ClassValue } from 'clsx';
export const cn = (...v: ClassValue[]) => clsx(v);

export type Tone = 'ok' | 'warn' | 'bad' | 'accent' | 'muted' | 'fg' | 'fg2' | 'fg3' | 'fg4' | 'fg5';
export const toneText: Record<Tone, string> = {
  ok: 'text-ok',
  warn: 'text-warn',
  bad: 'text-bad',
  accent: 'text-accent',
  muted: 'text-fg5',
  fg: 'text-fg',
  fg2: 'text-fg2',
  fg3: 'text-fg3',
  fg4: 'text-fg4',
  fg5: 'text-fg5',
};
export const toneBorder: Record<Tone, string> = {
  ok: 'border-ok',
  warn: 'border-warn',
  bad: 'border-bad',
  accent: 'border-accent',
  muted: 'border-fg5',
  fg: 'border-fg',
  fg2: 'border-fg2',
  fg3: 'border-fg3',
  fg4: 'border-fg4',
  fg5: 'border-fg5',
};

export type DeviceState = 'live' | 'standby' | 'offline' | 'updating' | 'locked';
/** Design: live -> accent, standby -> ok, everything else -> fg5 (locked -> warn in our build). */
export const stateTone = (s: DeviceState | string): Tone =>
  s === 'live' ? 'accent' : s === 'standby' ? 'ok' : s === 'locked' ? 'warn' : s === 'updating' ? 'warn' : s === 'downloading' ? 'accent' : 'fg5';
